var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErpImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2253 1468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:#dce5fe;}.cls-4{fill:#bdd0fb;}.cls-5{fill:#7d97f4;}.cls-6{fill:#18174a;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:#2b69b3;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:#fff;}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{opacity:0.21;fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}.cls-52{fill:url(#linear-gradient-45);}.cls-53{fill:url(#linear-gradient-46);}.cls-54{fill:url(#linear-gradient-47);}.cls-55{fill:url(#linear-gradient-48);}.cls-56{fill:url(#linear-gradient-49);}.cls-57{fill:url(#linear-gradient-50);}.cls-58{fill:url(#linear-gradient-51);}.cls-59{fill:url(#linear-gradient-52);}.cls-60{fill:url(#linear-gradient-53);}.cls-61{fill:url(#linear-gradient-54);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1725.97,
    y1: 914.59,
    x2: 248.43,
    y2: 914.59,
    gradientTransform: "matrix(-1.13, 0.14, 0.12, 0.99, 223.56, -17.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1677.71,
    y1: 1079.33,
    x2: 2000.29,
    y2: 1079.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1176.98,
    y1: 954.41,
    x2: 1606.9,
    y2: 954.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1631.51,
    y1: 877.24,
    x2: 683.81,
    y2: 1137.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1577.06,
    y1: 677.03,
    x2: 599.68,
    y2: 945.51,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 895.75,
    y1: 418.65,
    x2: 548.63,
    y2: 935.43,
    gradientTransform: "translate(1047.12 -455.73) rotate(71.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 955.03,
    y1: 458.47,
    x2: 607.91,
    y2: 975.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1097.48,
    y1: 779.66,
    x2: 855.67,
    y2: 1068.27,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 957.15,
    y1: 182,
    x2: 1009.63,
    y2: 182,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 926.6,
    y1: 247.09,
    x2: 941.55,
    y2: 247.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 855.74,
    y1: 264.22,
    x2: 919.45,
    y2: 264.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1016.31,
    y1: 280.35,
    x2: 317.24,
    y2: 1198.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3523.52,
    y1: 1461.56,
    x2: -3467.1,
    y2: 1461.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -1700.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -3523.52,
    y1: 1450.5,
    x2: -3468.7,
    y2: 1450.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -1700.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3518.31,
    y1: 1435.06,
    x2: -3502.42,
    y2: 1435.06,
    gradientTransform: "matrix(-1, 0, 0, 1, -1700.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3635.99,
    y1: 1460.34,
    x2: -3614.37,
    y2: 1460.34,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -3635.84,
    y1: 1443.69,
    x2: -3604.1,
    y2: 1443.69,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -3619.34,
    y1: 1421.81,
    x2: -3600.35,
    y2: 1421.81,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1897,
    y1: 1011.84,
    x2: 1678.59,
    y2: 1240,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -3555.34,
    y1: 1351.48,
    x2: -3546.24,
    y2: 1333.28,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -3261.48,
    y1: 514.8,
    x2: -3300.48,
    y2: 600.8,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1910.58,
    y1: 1024.84,
    x2: 1692.16,
    y2: 1253,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1856.11,
    y1: 972.7,
    x2: 1637.69,
    y2: 1200.86,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2628.35,
    y1: 489.16,
    x2: -2700.35,
    y2: 552.16,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1771.37,
    y1: 1066.69,
    x2: 1747.37,
    y2: 1020.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -3605.34,
    y1: 1189.65,
    x2: -3326.52,
    y2: 1189.65,
    gradientTransform: "matrix(-1, 0, 0, 1, -1700.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -3341.86,
    y1: 1066.02,
    x2: -3085.93,
    y2: 1066.02,
    gradientTransform: "matrix(-1, 0, 0, 1, -1700.1, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -3356.29,
    y1: 1066.02,
    x2: -3071.51,
    y2: 1066.02,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1783.16,
    y1: 984.44,
    x2: 1736.16,
    y2: 1005.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -3808.99,
    y1: 2088.42,
    x2: -3750.53,
    y2: 2088.42,
    gradientTransform: "matrix(-0.99, -0.14, -0.14, 0.99, -1711.79, -1598.03)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -3843.3,
    y1: 2124.08,
    x2: -3804.04,
    y2: 2083.8,
    gradientTransform: "matrix(-0.99, -0.14, -0.14, 0.99, -1711.79, -1598.03)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -3227.79,
    y1: 530.08,
    x2: -3266.79,
    y2: 616.08,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -2615.3,
    y1: 504.07,
    x2: -2687.3,
    y2: 567.07,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 429.59,
    y1: 454.33,
    x2: 487.58,
    y2: 586.29,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 609.11,
    y1: 912.99,
    x2: 635.73,
    y2: 912.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 496.63,
    y1: 1017.97,
    x2: 534.94,
    y2: 570.24,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 485.44,
    y1: 908.13,
    x2: 528.51,
    y2: 908.13,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 573.69,
    y1: 1024.63,
    x2: 612.01,
    y2: 576.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 474.47,
    y1: 480.89,
    x2: 465.47,
    y2: 538.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 522.09,
    y1: 602.3,
    x2: 569.89,
    y2: 602.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 489.17,
    y1: 469.03,
    x2: 467.33,
    y2: 496.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 478.7,
    y1: 462.83,
    x2: 457.17,
    y2: 489.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 418.12,
    y1: 459.37,
    x2: 476.12,
    y2: 591.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 390.56,
    y1: 410.71,
    x2: 404.09,
    y2: 410.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 970.57, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 639.64,
    y1: 1048.01,
    x2: -79.96,
    y2: 1867.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 571.51,
    y1: 988.18,
    x2: -148.08,
    y2: 1807.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 89.49,
    y1: 1196.07,
    x2: 326.11,
    y2: 1196.07,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 230.14,
    y1: 1196.07,
    x2: 466.76,
    y2: 1196.07,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 303.14,
    y1: 926.87,
    x2: 524.28,
    y2: 926.87,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 282.38,
    y1: 1010.15,
    x2: 432.36,
    y2: 1010.15,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 243.55,
    y1: 1111.46,
    x2: 384.62,
    y2: 1111.46,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 201.64,
    y1: 1212.76,
    x2: 342.72,
    y2: 1212.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 153.25,
    y1: 1314.06,
    x2: 303.22,
    y2: 1314.06,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 110.76,
    y1: 1415.37,
    x2: 260.74,
    y2: 1415.37,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1621.34,97.87c147,117.76,581.76-86.57,607.32,160.7,29.92,289.54-247.95,582.33-78.82,767.62s33.26,478.4-677.13,412.46c-581.24-54-1565-139.52-1374.52-443.85s39.18-300.14,13.19-421.09S166,170.52,642.23,339.09,1249.11-200.32,1621.34,97.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2223.69,753.38c-66.82,22-451.28,169.37-401.07,627,0,0,273.89-18.82,408.29-618.45C2232.09,756.72,2228.05,751.94,2223.69,753.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2182.57,821.34s-26.58,25.36-64.87,65c-9.57,9.91-19.89,20.7-30.68,32.21s-22.12,23.72-33.7,36.47-23.42,26-35.34,39.61-23.86,27.54-35.62,41.64c-5.9,7-11.76,14.1-17.51,21.21s-11.48,14.18-17.1,21.25c-11.25,14.13-22.06,28.25-32.36,42-5.17,6.87-10.07,13.76-15,20.43s-9.43,13.38-14,19.81-8.71,12.86-12.87,19-7.91,12.23-11.65,18-7.06,11.44-10.37,16.75c-1.62,2.68-3.24,5.26-4.73,7.82l-4.29,7.48c-2.73,4.85-5.46,9.31-7.68,13.59s-4.35,8.15-6.23,11.68-3.47,6.71-4.83,9.5l-3.47,7.07-2.88,5.89-.07.14a4,4,0,0,1-7.25-3.55l0,0,3-6c1-1.94,2.17-4.33,3.57-7.15s3-6.06,5-9.59l6.4-11.77c2.27-4.31,5.06-8.78,7.86-13.67l4.4-7.52c1.52-2.57,3.18-5.16,4.83-7.84,3.37-5.33,6.73-11.07,10.58-16.81s7.68-11.86,11.88-18,8.53-12.53,13.1-19,9.28-13.1,14.2-19.8,9.95-13.55,15.2-20.4c10.45-13.75,21.41-27.83,32.81-41.92,5.69-7,11.43-14.15,17.32-21.18s11.75-14.12,17.72-21.12c11.9-14,24-27.89,36-41.45s24-26.74,35.72-39.4,23.11-24.82,34-36.26,21.32-22.16,31-32c38.65-39.38,65.49-64.58,65.49-64.58a1.71,1.71,0,0,1,2.35,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1.94,1323.54c52.36-33.11,367.57-212.14,650.69,78,0,0-166,175.71-648.89-68.26C-.48,1331.12-1.48,1325.7,1.94,1323.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.76,1330.4s32.15-4.17,80.55-8.46c12.1-1.06,25.22-2.15,39.1-3.17s28.53-2,43.69-2.89,30.84-1.64,46.77-2.28,32.14-1.1,48.35-1.34c8.1-.15,16.2-.25,24.28-.25s16.11,0,24.09,0c16,.12,31.67.54,46.87,1.11,7.59.26,15.06.73,22.37,1.07s14.46,1,21.42,1.4,13.72,1.16,20.26,1.71,12.84,1.36,18.9,2,11.85,1.51,17.36,2.2c2.75.38,5.44.69,8.05,1.09l7.57,1.22c9.81,1.46,18.3,3.17,25.3,4.52,3.51.62,6.61,1.35,9.31,2l6.87,1.56,5.72,1.31a4,4,0,1,1-1.8,7.86h0l-.15,0-5.62-1.33-6.74-1.6c-2.65-.64-5.69-1.39-9.15-2-6.9-1.38-15.25-3.15-24.94-4.68l-7.48-1.27c-2.58-.42-5.24-.76-8-1.16-5.46-.73-11.17-1.69-17.18-2.33s-12.25-1.51-18.74-2.14-13.19-1.31-20.1-1.88-14-1.13-21.28-1.59-14.69-.93-22.26-1.26c-15.12-.71-30.75-1.26-46.65-1.52-7.95-.14-16-.27-24-.27s-16.12,0-24.2,0c-16.17.1-32.33.47-48.23.9s-31.56,1.1-46.7,1.86-29.77,1.58-43.64,2.49-27,1.87-39.06,2.82c-48.37,3.85-80.47,7.73-80.47,7.73a1.71,1.71,0,0,1-.43-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2146.46,425.94c-94.22,30.27-635.31,228.81-540.21,770,0,0,389.87-39,550.95-760.24A8.38,8.38,0,0,0,2146.46,425.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2090.64,509.16s-35.82,31-87.67,79.61c-13,12.15-26.93,25.4-41.59,39.52s-30,29.11-45.74,44.8-31.84,32-48.09,48.72l-24.35,25.41c-8,8.62-16.24,17.18-24.24,25.9s-16.09,17.37-23.93,26.17-15.76,17.48-23.41,26.27l-11.47,13.08L1749,851.73c-7.47,8.63-14.64,17.34-21.72,25.87-14.15,17.09-27.48,33.88-39.85,50s-23.74,31.6-33.89,46.13c-5.19,7.19-9.86,14.27-14.35,21l-6.57,9.8c-2.08,3.19-4,6.36-5.94,9.4-3.8,6.1-7.49,11.74-10.65,17.09l-8.61,14.76-3.67,6.32-3,5.69-4.78,9-4,7.47-.08.15a4,4,0,1,1-7.12-3.8v0l4.08-7.54,4.9-9,3.1-5.75,3.75-6.37c2.66-4.48,5.59-9.45,8.79-14.85s7-11.05,10.85-17.18c2-3,3.93-6.24,6-9.45s4.39-6.46,6.67-9.82c4.57-6.73,9.32-13.84,14.58-21,10.3-14.56,21.85-30,34.35-46.17s26-32.89,40.31-49.94c7.16-8.53,14.41-17.21,21.95-25.82l11.31-13.06,11.58-13c7.72-8.77,15.65-17.47,23.62-26.19s16.07-17.39,24.15-26.08,16.32-17.21,24.44-25.79l24.55-25.31c16.37-16.64,32.57-32.93,48.46-48.49s31.32-30.5,46.06-44.57,28.82-27.22,41.87-39.3c52.2-48.34,88.26-79.17,88.26-79.17a1.71,1.71,0,0,1,2.24,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.13,409.74c98.08,52.95,656.29,384.38,439.37,964.07,0,0-423.66-123.6-453.29-955.46A9.43,9.43,0,0,1,289.13,409.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.61,511.13S370.17,552.71,418,617c11.95,16.07,24.79,33.57,38.23,52.17s27.51,38.31,41.8,58.87,29,41.89,43.64,63.7l21.94,33.08c7.22,11.18,14.59,22.32,21.74,33.61S599.72,881,606.67,892.3q5.25,8.49,10.49,16.93t10.25,16.94L637.54,943l9.82,16.8c6.58,11.09,12.81,22.2,19,33.11,12.3,21.84,23.77,43.19,34.3,63.62s20.1,40,28.49,58.2c4.34,9,8.13,17.89,11.79,26.28l5.36,12.25c1.68,4,3.21,7.93,4.75,11.71,3,7.59,6,14.62,8.46,21.25l6.65,18.26,2.84,7.82,2.25,7,3.55,11,3,9.19a4,4,0,0,1-7.68,2.47v0l0-.16-2.87-9.1-3.46-10.92q-1-3.22-2.18-6.93c-.87-2.44-1.8-5-2.77-7.77l-6.5-18.12c-2.4-6.58-5.33-13.58-8.27-21.13-1.51-3.76-3-7.67-4.66-11.64L734,1144c-3.6-8.35-7.31-17.16-11.58-26.19-8.25-18.18-17.68-37.66-28-58.08s-21.69-41.75-33.84-63.58c-6.09-10.92-12.24-22-18.74-33.13q-4.82-8.36-9.7-16.8t-10-16.85q-5-8.46-10.14-17t-10.37-17c-6.88-11.36-14.05-22.6-21.12-33.91S566.11,839.05,559,827.85l-21.73-33.16c-14.55-21.86-29-43.29-43.23-63.86s-28.14-40.35-41.44-59-26.06-36.2-37.92-52.32c-47.41-64.51-80.7-106.22-80.7-106.22a1.71,1.71,0,0,1,2.67-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.84,766.68c92.73,13.07,629.23,111.17,627.6,631.15,0,0-369.82,26.34-636.05-620.31A7.92,7.92,0,0,1,32.84,766.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100,832.45s38.6,22.94,95.05,59.61c14.12,9.16,29.35,19.19,45.37,29.91s32.87,22.13,50.14,34.14,35.05,24.54,53,37.42l27,19.65c9,6.69,18,13.31,26.95,20.11s17.92,13.53,26.71,20.44,17.64,13.68,26.25,20.61l12.9,10.3L476,1095c8.42,6.81,16.58,13.74,24.62,20.54,16.08,13.6,31.36,27.07,45.64,40.09s27.52,25.6,39.47,37.52c6.07,5.86,11.64,11.73,17,17.26l7.8,8.09c2.5,2.66,4.85,5.31,7.17,7.84,4.6,5.1,9,9.77,12.89,14.27l10.59,12.45,4.52,5.33,3.82,4.86c2.38,3,4.4,5.58,6,7.66,3.28,4.15,5,6.37,5,6.37a4,4,0,1,1-6.34,5v0l-.11-.13-4.91-6.32-5.9-7.6-3.74-4.81-4.44-5.31-10.39-12.37c-3.81-4.49-8.15-9.15-12.67-14.23-2.29-2.52-4.6-5.16-7.06-7.81l-7.69-8.08c-5.27-5.53-10.76-11.39-16.76-17.25-11.79-11.91-24.9-24.51-39-37.57s-29.25-26.56-45.19-40.22c-8-6.82-16.06-13.78-24.41-20.63l-12.55-10.41-12.8-10.35c-8.54-7-17.27-13.85-26-20.73s-17.66-13.72-26.53-20.57-17.87-13.51-26.76-20.25l-26.79-19.78c-17.84-13-35.46-25.66-52.68-37.71s-33.93-23.58-49.85-34.42-31.08-20.93-45.13-30.17c-56.15-37-94.54-60.15-94.54-60.15a1.71,1.71,0,0,1,1.76-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1712.18,568.72a2,2,0,0,1-.75-3.75c2.37-1,4.74-2,7.06-3.12a2,2,0,0,1,1.65,3.54c-2.37,1.1-4.8,2.18-7.21,3.18A2,2,0,0,1,1712.18,568.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1640.53,583c-3.27,0-6.58-.09-9.84-.26a2,2,0,0,1-1.84-2.05,2,2,0,0,1,2-1.85c5.2.28,10.45.33,15.69.16h.07a2,2,0,0,1,.06,3.9C1644.64,582.92,1642.58,583,1640.53,583Zm31.74-2.7a1.95,1.95,0,0,1-.33-3.87c5.16-.88,10.32-2,15.34-3.3a1.95,1.95,0,1,1,1,3.77c-5.13,1.34-10.4,2.47-15.66,3.37Zm-67-.69a2.31,2.31,0,0,1-.37,0c-5.22-1-10.46-2.27-15.59-3.73a1.95,1.95,0,0,1,1.07-3.75c5,1.43,10.15,2.66,15.26,3.65a1.95,1.95,0,0,1-.37,3.86Zm-39.65-12.45a2,2,0,0,1-.78-.17c-4.87-2.16-9.71-4.55-14.36-7.11a1.95,1.95,0,0,1,1.87-3.42c4.57,2.51,9.3,4.85,14.07,7a1.95,1.95,0,0,1-.8,3.73Zm-35.87-21a1.94,1.94,0,0,1-1.16-.38c-4.27-3.18-8.45-6.59-12.43-10.11a2,2,0,0,1-.16-2.76,1.94,1.94,0,0,1,2.75-.16c3.9,3.45,8,6.78,12.17,9.9a1.95,1.95,0,0,1-1.17,3.51Zm-30.34-28.37a2,2,0,0,1-1.48-.68c-3.46-4.05-6.79-8.29-9.88-12.61a1.95,1.95,0,0,1,3.17-2.27c3,4.22,6.29,8.38,9.68,12.34a2,2,0,0,1-.22,2.75A2,2,0,0,1,1499.38,517.78Zm-23.29-34.38a2,2,0,0,1-1.73-1c-2.47-4.71-4.76-9.58-6.82-14.49a1.95,1.95,0,1,1,3.59-1.51c2,4.8,4.27,9.58,6.69,14.19a1.94,1.94,0,0,1-1.73,2.85Zm-15-38.71a2,2,0,0,1-1.88-1.45c-1.36-5.14-2.51-10.41-3.42-15.65a2,2,0,0,1,1.59-2.26,1.94,1.94,0,0,1,2.25,1.59c.9,5.14,2,10.29,3.35,15.32a2,2,0,0,1-1.39,2.39A2.14,2.14,0,0,1,1461.05,444.69Zm-6-41.1a2,2,0,0,1-2-1.88c-.08-2.26-.12-4.52-.12-6.76,0-3.09.08-6.2.23-9.26a1.95,1.95,0,0,1,3.89.19c-.14,3-.22,6.05-.22,9.07q0,3.3.12,6.62a2,2,0,0,1-1.88,2Zm3.16-41.43a1.55,1.55,0,0,1-.37,0,2,2,0,0,1-1.55-2.28c1-5.22,2.24-10.47,3.68-15.59a1.95,1.95,0,1,1,3.75,1.06c-1.41,5-2.62,10.15-3.6,15.26A2,2,0,0,1,1458.16,362.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1470.54,322.36a2,2,0,0,1-.78-.17,2,2,0,0,1-1-2.57c1-2.37,2.16-4.78,3.32-7.14a1.95,1.95,0,0,1,3.5,1.72c-1.13,2.32-2.23,4.67-3.25,7A2,2,0,0,1,1470.54,322.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1576.67,222.59a1.95,1.95,0,0,1-.67-3.78c2.47-.9,5-1.76,7.46-2.55a1.95,1.95,0,1,1,1.18,3.71c-2.42.78-4.88,1.62-7.3,2.5A1.93,1.93,0,0,1,1576.67,222.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1817,456.11a1.94,1.94,0,0,1-1.84-2.57c1.62-4.85,3.07-9.84,4.28-14.83a2,2,0,0,1,3.79.93c-1.24,5.09-2.71,10.19-4.38,15.15A1.94,1.94,0,0,1,1817,456.11Zm8.63-40h-.2a2,2,0,0,1-1.74-2.14c.52-5.1.83-10.28.92-15.41a1.93,1.93,0,0,1,2-1.92,2,2,0,0,1,1.92,2c-.1,5.23-.41,10.53-.94,15.74A2,2,0,0,1,1825.64,416.15Zm-.34-40.89a2,2,0,0,1-1.94-1.72c-.6-5.1-1.42-10.23-2.44-15.24a2,2,0,0,1,3.83-.78c1,5.12,1.87,10.35,2.49,15.56a2,2,0,0,1-1.71,2.17Zm-9.19-39.82a1.94,1.94,0,0,1-1.84-1.31c-1.7-4.83-3.62-9.65-5.72-14.33a1.95,1.95,0,1,1,3.55-1.6c2.15,4.78,4.11,9.7,5.85,14.64a2,2,0,0,1-1.2,2.49A2.05,2.05,0,0,1,1816.11,335.44Zm-17.71-36.82a2,2,0,0,1-1.66-.91c-2.71-4.35-5.65-8.63-8.72-12.73a1.95,1.95,0,1,1,3.12-2.33c3.14,4.18,6.13,8.55,8.91,13a1.94,1.94,0,0,1-1.65,3Zm-25.36-32a2,2,0,0,1-1.38-.58c-3.61-3.65-7.41-7.19-11.3-10.52a2,2,0,0,1,2.54-3c4,3.4,7.85,7,11.53,10.74a2,2,0,0,1,0,2.76A1.92,1.92,0,0,1,1773,266.58Zm-31.73-25.77a2,2,0,0,1-1-.31c-4.33-2.79-8.81-5.42-13.32-7.82a1.95,1.95,0,1,1,1.83-3.44c4.61,2.45,9.19,5.13,13.6,8a2,2,0,0,1-1.06,3.59Zm-36.59-18.24a1.93,1.93,0,0,1-.67-.12c-4.82-1.77-9.76-3.36-14.71-4.71a1.95,1.95,0,0,1,1-3.76c5.05,1.38,10.11,3,15,4.8a2,2,0,0,1-.67,3.79ZM1608.66,214a1.95,1.95,0,0,1-.33-3.87c5.14-.9,10.4-1.59,15.63-2.06a1.94,1.94,0,0,1,2.12,1.77,2,2,0,0,1-1.77,2.12c-5.13.46-10.28,1.13-15.31,2A2,2,0,0,1,1608.66,214ZM1665,212.8h-.26c-5.08-.67-10.25-1.12-15.37-1.36a1.95,1.95,0,1,1,.17-3.89c5.23.24,10.52.7,15.7,1.38a1.95,1.95,0,0,1-.24,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1803.66,486.55a2,2,0,0,1-.94-.24,2,2,0,0,1-.77-2.65c1.25-2.26,2.45-4.56,3.58-6.84a1.95,1.95,0,0,1,3.49,1.74c-1.15,2.32-2.38,4.67-3.65,7A2,2,0,0,1,1803.66,486.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1756.23,479.09a2.24,2.24,0,0,0,.3-2.58l-13.1-23.78a118.19,118.19,0,0,0,12.89-36.08l25.17-10.12a2.24,2.24,0,0,0,1.4-2.18l-1.63-32.52a2.24,2.24,0,0,0-1.61-2l-26.06-7.55a118.27,118.27,0,0,0-16.43-34.62l10.66-25a2.23,2.23,0,0,0-.56-2.53l-24.15-21.84a2.22,2.22,0,0,0-2.57-.3l-23.78,13.1a118.38,118.38,0,0,0-36.08-12.89L1650.56,253a2.22,2.22,0,0,0-2.18-1.4l-32.53,1.63a2.23,2.23,0,0,0-2,1.61l-7.55,26.06a118.07,118.07,0,0,0-34.61,16.42l-25-10.65a2.24,2.24,0,0,0-2.53.55l-21.85,24.15a2.24,2.24,0,0,0-.3,2.58l13.1,23.78a118.19,118.19,0,0,0-12.89,36.08L1497.05,384a2.24,2.24,0,0,0-1.4,2.18l1.63,32.52a2.24,2.24,0,0,0,1.61,2l26.06,7.55a118.27,118.27,0,0,0,16.43,34.62l-10.66,25a2.23,2.23,0,0,0,.56,2.53l24.15,21.84a2.22,2.22,0,0,0,2.57.3l23.78-13.09a118.63,118.63,0,0,0,36.08,12.88L1628,537.47a2.23,2.23,0,0,0,2.18,1.39l32.53-1.63a2.23,2.23,0,0,0,2-1.61l7.55-26.05a118.35,118.35,0,0,0,34.61-16.43l25,10.65a2.23,2.23,0,0,0,2.53-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1639.29,427.09a31.89,31.89,0,0,1-30.46-22.52,31.83,31.83,0,1,1,30.46,22.52Zm0-57.85a26,26,0,1,0,24.82,18.39h0a26,26,0,0,0-24.82-18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1638.67,476.33a81.6,81.6,0,0,1-81.35-77.43c-.07-1.38-.1-2.75-.1-4.12a81.5,81.5,0,0,1,162.9-4c.07,1.37.1,2.74.1,4.12a80.78,80.78,0,0,1-1.07,13.2l-5.77-.94a76.13,76.13,0,0,0,1-12.26c0-1.28,0-2.56-.09-3.83h0a75.65,75.65,0,0,0-151.21,3.71c0,1.28,0,2.57.09,3.86a75.67,75.67,0,0,0,117.6,59.12l3.26,4.86a81.36,81.36,0,0,1-41.22,13.63C1641.42,476.29,1640,476.33,1638.67,476.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1532.87,264.34l-8.37-12.7a66.31,66.31,0,0,0,5.59-20.73l13.61-6.77a1.24,1.24,0,0,0,.69-1.28L1542,204.77a1.23,1.23,0,0,0-1-1.06l-14.89-3.06A66.35,66.35,0,0,0,1515.44,182l4.84-14.42a1.24,1.24,0,0,0-.42-1.38l-14.46-11.13a1.25,1.25,0,0,0-1.45-.06l-12.7,8.37a66.25,66.25,0,0,0-20.72-5.59l-6.77-13.61a1.24,1.24,0,0,0-1.28-.68l-18.09,2.35a1.27,1.27,0,0,0-1.07,1l-3.06,14.89a66.27,66.27,0,0,0-18.6,10.71l-14.42-4.84a1.26,1.26,0,0,0-1.39.42l-11.13,14.46a1.26,1.26,0,0,0,0,1.45l8.37,12.7a66.24,66.24,0,0,0-5.59,20.73l-13.61,6.76a1.26,1.26,0,0,0-.69,1.28l2.36,18.1a1.24,1.24,0,0,0,1,1.06l14.89,3.06a66.29,66.29,0,0,0,10.72,18.6l-4.84,14.42a1.25,1.25,0,0,0,.42,1.39l14.46,11.13a1.23,1.23,0,0,0,1.45.05l12.7-8.37a66.27,66.27,0,0,0,20.72,5.6l6.77,13.61a1.24,1.24,0,0,0,1.28.68l18.09-2.35a1.27,1.27,0,0,0,1.07-1l3.06-14.89a66.27,66.27,0,0,0,18.6-10.71l14.42,4.84a1.26,1.26,0,0,0,1.39-.42l11.13-14.46A1.26,1.26,0,0,0,1532.87,264.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1463.77,243.29a19.13,19.13,0,1,1,17.79-26.17h0a19.15,19.15,0,0,1-17.79,26.17Zm0-32.41a13.28,13.28,0,1,0,12.36,8.39A13.19,13.19,0,0,0,1463.75,210.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1523.07,303.9a1.95,1.95,0,0,1-1.18-3.5c2-1.54,4-3.18,5.89-4.87a1.94,1.94,0,0,1,2.75.14,2,2,0,0,1-.15,2.76c-2,1.76-4,3.46-6.13,5.07A1.93,1.93,0,0,1,1523.07,303.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1462.57,323.93h0a99.59,99.59,0,0,1-15.5-1.42,1.95,1.95,0,0,1,.66-3.84,96.64,96.64,0,0,0,14.89,1.36,2,2,0,0,1,0,3.9Zm24.58-2.85a1.95,1.95,0,0,1-.47-3.84,99.34,99.34,0,0,0,12.33-3.95l1.87-.76a1.95,1.95,0,1,1,1.51,3.59l-1.94.79a100.75,100.75,0,0,1-12.83,4.11A1.89,1.89,0,0,1,1487.15,321.08Zm-63.45-5.75a1.89,1.89,0,0,1-.8-.17,100.27,100.27,0,0,1-13.66-7.45,2,2,0,1,1,2.13-3.27,96.35,96.35,0,0,0,13.13,7.16,2,2,0,0,1-.8,3.73ZM1391.45,292a1.93,1.93,0,0,1-1.44-.63,99.58,99.58,0,0,1-9.55-12.29,1.95,1.95,0,0,1,3.26-2.14,95.09,95.09,0,0,0,9.17,11.8,1.94,1.94,0,0,1-.13,2.75A1.88,1.88,0,0,1,1391.45,292Zm-20.25-34.27a1.93,1.93,0,0,1-1.84-1.31,99.85,99.85,0,0,1-3.89-15.07,1.95,1.95,0,1,1,3.84-.68,95.93,95.93,0,0,0,3.74,14.48,1.94,1.94,0,0,1-1.85,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1366.24,218.15h-.16a2,2,0,0,1-1.78-2.11c.21-2.62.54-5.28,1-7.89a2,2,0,1,1,3.85.63c-.41,2.51-.73,5.06-.93,7.58A2,2,0,0,1,1366.24,218.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1404.81,148a2,2,0,0,1-1.17-3.51c2.1-1.59,4.31-3.11,6.54-4.53a2,2,0,0,1,2.09,3.3c-2.15,1.36-4.26,2.82-6.28,4.35A2,2,0,0,1,1404.81,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1560.85,214.12a2,2,0,0,1-1.94-1.71A95.12,95.12,0,0,0,1556,198a2,2,0,0,1,3.76-1.07,100.19,100.19,0,0,1,3,15,2,2,0,0,1-1.69,2.18ZM1548.37,177a2,2,0,0,1-1.69-1,97,97,0,0,0-8.32-12.12,1.95,1.95,0,1,1,3-2.45,99.25,99.25,0,0,1,8.66,12.62,2,2,0,0,1-.71,2.66A1.91,1.91,0,0,1,1548.37,177Zm-26-29.24a1.94,1.94,0,0,1-1.16-.38,96.42,96.42,0,0,0-12.42-7.87,2,2,0,0,1,1.83-3.45,101.34,101.34,0,0,1,12.92,8.19,1.95,1.95,0,0,1-1.17,3.51Zm-89.1-14.59a2,2,0,0,1-.61-3.81,99.49,99.49,0,0,1,14.86-3.66,1.93,1.93,0,0,1,2.24,1.6,2,2,0,0,1-1.6,2.25,95.72,95.72,0,0,0-14.28,3.52A1.86,1.86,0,0,1,1433.24,133.17Zm53.69-2.11a1.85,1.85,0,0,1-.46-.05,95.25,95.25,0,0,0-14.51-2.39,2,2,0,0,1,.34-3.89,100.33,100.33,0,0,1,15.1,2.49,1.95,1.95,0,0,1-.47,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1559.48,246.24a1.9,1.9,0,0,1-.41,0,2,2,0,0,1-1.5-2.31c.52-2.5,1-5,1.28-7.54a2,2,0,0,1,3.87.5c-.34,2.61-.79,5.24-1.34,7.84A1.94,1.94,0,0,1,1559.48,246.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1463.41,270.9a46.91,46.91,0,1,1,46.86-43.43l0,.4-5.83-.48c.09-1.12.14-2.25.14-3.38a42,42,0,0,0-.35-5.37,41.09,41.09,0,1,0-15.28,37.56l3.63,4.59a47,47,0,0,1-23,9.71A46.47,46.47,0,0,1,1463.41,270.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1990.18,744.65l27.61,1.73a25.64,25.64,0,0,1,24,26l-9.64,655.28a26.9,26.9,0,0,1-27.47,26.49l-189.61-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1659,745.2l350-16.92a12.42,12.42,0,0,1,13,12.8l-21.59,675.23a26,26,0,0,1-27,25.1l-246-9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1677.71,759.4l307.88-39.28a13.05,13.05,0,0,1,14.7,13.23l-15,681A18,18,0,0,1,1967.8,1432l-226.5,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1596.79,725.54l337.54-21a29.23,29.23,0,0,1,31.05,29.17v695.46a25.54,25.54,0,0,1-25.54,25.53H1628.63a27.63,27.63,0,0,1-27.59-26.15l-35.93-667.41A33.84,33.84,0,0,1,1596.79,725.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1939.14,
    y: 770.88,
    width: 52.47,
    height: 207.53,
    rx: 9.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1593.44,508.36l36.79,2.3a34.17,34.17,0,0,1,32,34.6l-12.84,873.35a35.86,35.86,0,0,1-36.61,35.31l-252.71-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1152.07,509.09l466.54-22.56A16.55,16.55,0,0,1,1636,503.59l-28.78,899.94a34.6,34.6,0,0,1-36,33.46l-327.91-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1177,528l410.33-52.36a17.4,17.4,0,0,1,19.59,17.64l-20,907.68a24,24,0,0,1-23.33,23.51l-301.88,8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1069.13,482.89l449.87-28a39,39,0,0,1,41.37,38.88v926.9a34,34,0,0,1-34,34H1111.56a36.83,36.83,0,0,1-36.77-34.85L1026.9,530.32A45.1,45.1,0,0,1,1069.13,482.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1525.4,
    y: 543.32,
    width: 69.93,
    height: 276.6,
    rx: 9.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M633.14,293.64h712.27a73.79,73.79,0,0,1,73.69,70l52.58,1032.65a54.43,54.43,0,0,1-53.36,57.18L602,1468.33a51.65,51.65,0,0,1-52.59-51.64V377.39A83.75,83.75,0,0,1,633.14,293.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M721.29,1450.78h0l-91.34-1.18a56.34,56.34,0,0,1-55.4-56.12V1255.57a2,2,0,0,1,3.91,0v137.91A52.43,52.43,0,0,0,630,1445.7l91.34,1.18a2,2,0,0,1,0,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M576.48,1214.8a2,2,0,0,1-2-2v-22.33a2,2,0,0,1,3.91,0v22.33A2,2,0,0,1,576.48,1214.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M635.33,297c97.27,13.19,431.74,54,708.28,32.75a22.51,22.51,0,0,1,24.23,21.22L1423,1388.19a25.89,25.89,0,0,1-24.32,27.23c-116.3,6.88-595.29,33.49-766.14,15.59a20.5,20.5,0,0,1-18.35-20.3L607.74,321.23A24.32,24.32,0,0,1,635.33,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M645.75,323.87c93.6,12.7,415.48,51.95,681.61,31.53a21.64,21.64,0,0,1,23.31,20.41l53,998.2a24.91,24.91,0,0,1-23.4,26.2c-111.93,6.62-572.88,32.23-737.3,15a19.75,19.75,0,0,1-17.66-19.54L619.2,347.22A23.41,23.41,0,0,1,645.75,323.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M705.85,424.18l9.94,214a13.6,13.6,0,0,0,13.2,13c39.63,1.12,163.13,4.13,232.87.5A15.2,15.2,0,0,0,976.25,637c1.33-40.13,4.24-156.94-4.91-205.77a17.15,17.15,0,0,0-16.28-13.95L720.8,409.06A14.45,14.45,0,0,0,705.85,424.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 840.64,
    cy: 500.69,
    r: 46,
    transform: "translate(98.02 1137.78) rotate(-71.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M770.77,635.76H917.33a11.34,11.34,0,0,0,9.53-17.49c-12.45-19.48-38.49-48.1-83.6-46.81-43.48,1.25-69.25,27.09-82.2,45.63A11.86,11.86,0,0,0,770.77,635.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1296.28,442.81a3.87,3.87,0,0,0,3.88-4l-.18-6.36a4.25,4.25,0,0,0-4.12-4.07l-265.58-4.73a2.6,2.6,0,0,0-2.67,3.7l4.12,11.69a6.07,6.07,0,0,0,5.33,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1030.28,463.54a2.61,2.61,0,0,0-2.67,3.71l4.12,11.68a6.07,6.07,0,0,0,5.33,3.78h259.22a3.87,3.87,0,0,0,3.88-4l-.18-6.36a4.25,4.25,0,0,0-4.12-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1030.28,504a2.6,2.6,0,0,0-2.67,3.7l4.12,11.69a6.07,6.07,0,0,0,5.33,3.77h259.22a3.87,3.87,0,0,0,3.88-4l-.18-6.36a4.25,4.25,0,0,0-4.12-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.78,539.52c19.81-1.52,56.92-2.23,77.34-2.51a18.49,18.49,0,0,1,18.27,14.15c3.95,16.35,9.38,44.72,8.7,74.78A16.45,16.45,0,0,1,1290.5,642l-75.37-.81a18.1,18.1,0,0,1-17.82-16.42l-6.63-70.9A13.19,13.19,0,0,1,1202.78,539.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1160.18,575.58a3.94,3.94,0,0,0,3.94-4l-.09-6.36a4.27,4.27,0,0,0-4-4.15l-127.23-4.58a3.12,3.12,0,0,0-3.31,3.79l2,11.36a5,5,0,0,0,4.69,3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1032.45,603.6a3.11,3.11,0,0,0-3.17,3.92l2.39,11.27a5,5,0,0,0,4.83,3.77l124-4.54a3.94,3.94,0,0,0,3.79-4.14l-.32-6.35a4.27,4.27,0,0,0-4.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1321.23,718.37a3.71,3.71,0,0,0,3.74-4l-.42-6.37a4.4,4.4,0,0,0-4.27-4l-610.5-4.81c-2.2,0-2.88,1.38-1.51,3.1l10.33,13a9.38,9.38,0,0,0,6.49,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M709.78,739.07c-2.2,0-2.88,1.37-1.51,3.09l10.33,13a9.42,9.42,0,0,0,6.49,3.13h596.14a3.71,3.71,0,0,0,3.74-4l-.42-6.38a4.4,4.4,0,0,0-4.27-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M711.41,805.71c14.47-1.11,41.56-1.62,56.48-1.83a13.52,13.52,0,0,1,13.35,10.34c2.87,11.93,6.84,32.66,6.35,54.61a12,12,0,0,1-12.12,11.76l-55-.6a13.22,13.22,0,0,1-13-12l-4.84-51.78A9.63,9.63,0,0,1,711.41,805.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M808.86,826.79a3.19,3.19,0,0,0-3.41,3.79l2.63,17.47a4.8,4.8,0,0,0,4.59,4H955.05a4,4,0,0,0,4-4l-.14-11a4.3,4.3,0,0,0-4.05-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1011.28,805.71c14.47-1.11,41.57-1.62,56.48-1.83a13.52,13.52,0,0,1,13.35,10.34c2.88,11.93,6.85,32.66,6.35,54.61a12,12,0,0,1-12.11,11.76l-55-.6a13.22,13.22,0,0,1-13-12l-4.84-51.78A9.64,9.64,0,0,1,1011.28,805.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1108.73,826.79a3.18,3.18,0,0,0-3.4,3.79l2.62,17.47a4.8,4.8,0,0,0,4.59,4h142.38a4,4,0,0,0,3.95-4l-.14-11a4.29,4.29,0,0,0-4-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1289,984.94a3.71,3.71,0,0,0,3.74-4l-.41-6.38a4.37,4.37,0,0,0-4.25-4l-593.19-4.81c-2.2,0-2.9,1.39-1.55,3.13l10,12.91a9.2,9.2,0,0,0,6.44,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.87,1005.63c-2.2,0-2.9,1.39-1.55,3.13l10,12.91a9.2,9.2,0,0,0,6.44,3.16H1289a3.71,3.71,0,0,0,3.74-4l-.41-6.37a4.37,4.37,0,0,0-4.25-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.87,1046.11c-2.2,0-2.9,1.39-1.55,3.13l10,12.91a9.2,9.2,0,0,0,6.44,3.16H1289a3.71,3.71,0,0,0,3.74-4l-.41-6.38a4.37,4.37,0,0,0-4.25-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1033.45,152.84c-25.73-17.9-48.1-17.54-63.85-12.9a31.43,31.43,0,0,0-22.31,33l6.79,74.12,80.82,7.18S1083.91,187.94,1033.45,152.84Zm-35.54,59.8a20.15,20.15,0,1,1,20.15-20.15A20.15,20.15,0,0,1,997.91,212.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M962.16,215.91a2,2,0,0,1-1.94-1.77l-1.08-11.81A1.95,1.95,0,1,1,963,202l1.08,11.8a1.94,1.94,0,0,1-1.76,2.12ZM960,192.78A2,2,0,0,1,958.1,191l-.82-9a30,30,0,0,1,21.25-31.46,60.52,60.52,0,0,1,29.54-1.21,1.95,1.95,0,1,1-.78,3.82,56.61,56.61,0,0,0-27.65,1.13,26.09,26.09,0,0,0-18.48,27.37l.82,9a2,2,0,0,1-1.76,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M843.79,295V257.73A22.74,22.74,0,0,1,867.31,235l257,8.8a22.12,22.12,0,0,1,21.32,20.79l2.15,35.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M939.6,249H928.55a1.95,1.95,0,1,1,0-3.9H939.6a1.95,1.95,0,0,1,0,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M857.69,283.3a2,2,0,0,1-2-1.95V266.27a21.16,21.16,0,0,1,21.13-21.13H917.5a1.95,1.95,0,1,1,0,3.9H876.87a17.25,17.25,0,0,0-17.23,17.23v15.08A2,2,0,0,1,857.69,283.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M763.27,281.36h449.34a33.2,33.2,0,0,1,32.72,27.54l.38,2.2a28.52,28.52,0,0,1-28.1,33.39h-461A18.55,18.55,0,0,1,738.1,325l1-20.63A24.21,24.21,0,0,1,763.27,281.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1768.6,1458.83c9.66.83,26.44,2.19,39.66,2.77,8,.35,12.53-.43,15.16-1.48,0,.3,0,.58,0,.84a2.73,2.73,0,0,1-2.6,2.58,465.61,465.61,0,0,1-51.93,0,1.94,1.94,0,0,1-1.59-2.92A14.88,14.88,0,0,1,1768.6,1458.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1808.26,1461.6c-13.22-.58-30-1.94-39.66-2.77,9.5-11.66,39.66-19.52,39.66-19.52h8.52a35.68,35.68,0,0,1,6.64,20.81C1820.79,1461.17,1816.21,1462,1808.26,1461.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1818.21,1425.41l-.79,15.77a3.62,3.62,0,0,1-3.08,3.39,14.13,14.13,0,0,1-6.4-.53,4.27,4.27,0,0,1-2.86-3.28l-2.76-15.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1928.86,1461.48c4.19-.58,6.08-2.76,6.88-5.09v.07c.62,2.45-.81,5-3.67,6.21a24,24,0,0,1-10.16,1.59,10.08,10.08,0,0,1-7.62-3.52l0,0C1917.43,1462.27,1921.87,1462.46,1928.86,1461.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1909.09,1425.3h7c10.7-.21,17.42,22.35,19.62,31.09-.8,2.33-2.69,4.51-6.88,5.09-7,1-11.43.79-14.58-.77-5.79-7.6-8.65-18.75-10-25.25A8.87,8.87,0,0,1,1909.09,1425.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1915.22,1410.66l3.9,15.52a4.22,4.22,0,0,1-2.19,4.77c-2.19,1.12-5.26,2.3-8.08,2a3.52,3.52,0,0,1-2.87-2.35l-5.73-16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1919.87,1415.15c-4.85,4.3-20.64,4.87-20.64,4.87-56.86-136.48-80.12-155.86-80.12-155.86,8.21,51.51,1.32,165.55,1.32,165.55-9.38,4.14-21.48,0-21.48,0a878.58,878.58,0,0,0-29-215.86c38.43-.86,58.87-14,65.55-19.29C1867.49,1246.2,1919.87,1415.15,1919.87,1415.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1825.7,1037.61c7.27,36.28,4.66,101.23,3,130.85-.48,8.32,5.33,19.87,10,27.74a2.46,2.46,0,0,1-1,3.47c-7.86,4-34.51,16.58-65.39,18.13a4.38,4.38,0,0,1-4.43-3.29c-22.91-85.53-49.52-140.19-49.52-140.19C1747.72,1027.42,1825.7,1037.61,1825.7,1037.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1815.23,1260.92a1.78,1.78,0,0,0,.94-.26,1.82,1.82,0,0,0,.61-2.5,57.16,57.16,0,0,0-22.54-19.58,1.82,1.82,0,1,0-1.59,3.28,54.51,54.51,0,0,1,21,18.19A1.82,1.82,0,0,0,1815.23,1260.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1871.32,1141.74c-2.33,16.91-9.24,35.35-23,54.93l-5.25-4.28a162.2,162.2,0,0,0,2.62-52.49C1854.16,1138.23,1864.22,1140,1871.32,1141.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1817.57,1082.38l8.13-44.77s54.28,41.49,45.62,104.13c-7.1-1.79-17.16-3.51-25.68-1.84C1843.16,1119.79,1835.74,1098,1817.57,1082.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1718.34,1074.32l21,45.13c-3.39,27.25-18,39-33.81,43.55a95.77,95.77,0,0,0-7-29.39C1718.62,1112.79,1718.34,1074.32,1718.34,1074.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1698.46,1133.61a95.77,95.77,0,0,1,7,29.39c-42.1,16.33-53.24-15.35-53.24-15.35l7.78-1.37C1677.6,1148.13,1689.88,1142.47,1698.46,1133.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1737.65,1018.61l10.12,37.19a7.22,7.22,0,0,0,9.67,4.81A145.41,145.41,0,0,0,1772,1054a9.75,9.75,0,0,0,3.44-14l-21-31.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1633,1122.77l259.22,94.34a19.85,19.85,0,0,1,11.28,26.87l-.78,1.73a18.46,18.46,0,0,1-24.55,9.11l-251.7-116.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 1513.8,
    cy: 1066.02,
    rx: 127.96,
    ry: 125.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1371.41,1066c0,77.23,63.75,139.83,142.39,139.83s142.39-62.6,142.39-139.83-63.75-139.82-142.39-139.82S1371.41,988.79,1371.41,1066Zm20.92,0c0-65.87,54.38-119.28,121.47-119.28s121.47,53.41,121.47,119.28-54.38,119.29-121.47,119.29S1392.33,1131.89,1392.33,1066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1645.24,1083.35a1,1,0,0,1-.84-1.09c.41-3.26.71-6.58.87-9.88a.94.94,0,0,1,1-.93,1,1,0,0,1,.93,1c-.17,3.34-.47,6.72-.89,10a1,1,0,0,1-1,.85Zm-1.81-39.9a127.21,127.21,0,0,0-7.57-25.89h0c-20.23-49.06-68.14-80.77-122.06-80.77a133,133,0,0,0-70.69,20.2,1,1,0,0,1-1-1.65,134.91,134.91,0,0,1,71.72-20.5c54.72,0,103.34,32.18,123.87,82a128.83,128.83,0,0,1,7.68,26.29,1,1,0,0,1-.79,1.13l-.17,0A1,1,0,0,1,1643.43,1043.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1715.52,990.35c-.09.64,8.44,42.44,8.44,42.44l23.76-5.37-2.2-40.82S1717.06,979.66,1715.52,990.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1740.18,995.69l2.84,21.4a3.22,3.22,0,0,1,0,.82c-.24,1.68-1.48,7.39-7.25,5.75-5.23-1.48-10-2.75-13.34-1.74a3,3,0,0,0-2.07,3.49,130.43,130.43,0,0,0,5.47,19.47,3,3,0,0,0,3.65,1.78c4.51-1.31,13.94-4.35,21-8.57a3,3,0,0,0,1.47-2.71c-.23-5.41-.86-21.83-.33-26.43.5-4.32,5.8-6.91,8.1-7.83a3,3,0,0,0,1.65-1.66c1.07-2.67,2.54-8.86-5.25-11.39a3,3,0,0,1-1.92-3.91c1.16-3.21,1.65-8.12-4.39-10.82s-10.7.52-13.18,3.18a3,3,0,0,1-3.84.45,2.38,2.38,0,0,0-2.71.09,3,3,0,0,1-4.21-1.27c-1.47-3-4.46-6.24-10.46-5.22-10.65,1.83-11.85,13.63-9,20.54s14.24,4.28,20,.8c4.36-2.65,10,.13,12.48,1.61A3,3,0,0,1,1740.18,995.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1752.52,1016.75s-4.38-12.26.12-15.26,11.15-1.44,9.69,7.44C1760.5,1020,1752.52,1016.75,1752.52,1016.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1845.19,1191.64l-24.51-2-10.61,9.78s2.51,3.47,10.36,1.48,18.6-2.49,18.6-2.49,10.84,4.89,11-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1655.37,1153.45c-2.12,1.66-9.38-1.8-13.82-4.19a5.1,5.1,0,0,1-2.47-6c1.06-3.37,2.85-7.73,5-8.27C1647.76,1134,1664.1,1146.63,1655.37,1153.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1887.06,1251.21a1.25,1.25,0,0,0,.32,0c10.13-3.51,12.49-9.5,12.68-13.91a15.44,15.44,0,0,0-10.07-14.87l-31.12-12.14a1,1,0,0,0-.71,1.82l31.13,12.13a13.49,13.49,0,0,1,8.82,13c-.24,5.53-4.06,9.62-11.37,12.14a1,1,0,0,0,.32,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1848.92,1208.38a1,1,0,0,0,.36-1.88l-4-1.57a1,1,0,1,0-.71,1.81l4,1.58A1.12,1.12,0,0,0,1848.92,1208.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1665.53,806.82l5.38-2.26h0a1.54,1.54,0,0,1,1.19,2.83h0l-5.46,2.18a1.48,1.48,0,0,1-1.13-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1683.29,799l5.24-2.54h0a1.72,1.72,0,1,1,1.5,3.09h0l-5.33,2.46a1.66,1.66,0,0,1-1.43-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1700.59,790.17l5.09-2.82h0a1.9,1.9,0,0,1,1.84,3.32l0,0-5.2,2.75a1.84,1.84,0,0,1-1.76-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1717.39,780.48l4.93-3.08,0,0a2,2,0,0,1,2.16,3.46h0l-5,3a2,2,0,0,1-2.1-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1733.62,769.88l4.74-3.36,0,0a2.18,2.18,0,0,1,2.52,3.55l0,0L1736,773.4a2.14,2.14,0,0,1-2.45-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1749.18,758.36l4.53-3.64,0,0a2.31,2.31,0,0,1,2.89,3.61l0,0L1752,762a2.27,2.27,0,0,1-2.82-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1764,745.91l4.29-3.91,0,0a2.45,2.45,0,0,1,3.3,3.62l0,0-4.41,3.91A2.4,2.4,0,0,1,1764,746Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1778,732.55l4-4.19,0,0a2.58,2.58,0,1,1,3.73,3.57l0,0-4.15,4.2a2.54,2.54,0,0,1-3.65-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1791,718.28l3.71-4.45,0-.05a2.72,2.72,0,0,1,4.19,3.48l0,0-3.84,4.49a2.68,2.68,0,0,1-4.1-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1803,703.13l3.36-4.71,0,0a2.86,2.86,0,0,1,4.66,3.31l0,0-3.5,4.76a2.81,2.81,0,0,1-4.56-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1813.74,687.15l3-4.94,0-.06a2.95,2.95,0,1,1,5,3.05v0l-3.11,5a2.92,2.92,0,0,1-5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1823.23,670.4l2.58-5.17,0-.06a3,3,0,1,1,5.43,2.7v0l-2.69,5.27a3,3,0,0,1-5.37-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1831.28,652.94l2.1-5.36,0-.08a3.11,3.11,0,1,1,5.8,2.27v0L1837,655.3a3.09,3.09,0,0,1-5.75-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1837.69,634.84l1.6-5.54,0-.08a3.2,3.2,0,0,1,6.16,1.77v0l-1.69,5.69a3.18,3.18,0,0,1-6.1-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1842.42,616.22l1.09-5.65,0-.09a3.28,3.28,0,0,1,6.45,1.24v0l-1.17,5.82a3.26,3.26,0,0,1-6.39-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1845.46,597.26l.58-5.73v-.09a3.37,3.37,0,0,1,6.7.68v0l-.65,5.9a3.34,3.34,0,0,1-6.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1846.79,578.12l.06-5.76v-.09a3.45,3.45,0,1,1,6.9.07v0l-.11,5.94a3.43,3.43,0,0,1-6.85-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1846.38,558.94l-.47-5.73v-.1a3.54,3.54,0,1,1,7-.57v0l.43,5.93a3.51,3.51,0,0,1-7,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1844.19,539.91l-1-5.66,0-.1a3.62,3.62,0,1,1,7.12-1.27v0l1,5.87a3.59,3.59,0,0,1-7.07,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1840.17,521.2l-1.57-5.52,0-.11a3.7,3.7,0,1,1,7.12-2v0l1.58,5.75a3.68,3.68,0,0,1-7.08,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1834.28,503l-2.14-5.32,0-.11a3.78,3.78,0,0,1,7-2.83v0l2.18,5.57a3.75,3.75,0,0,1-7,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1826.49,485.62l-2.7-5-.07-.12a3.86,3.86,0,1,1,6.8-3.64h0l2.8,5.29a3.84,3.84,0,0,1-6.79,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1816.83,469.2l-3.26-4.69-.08-.11a3.88,3.88,0,1,1,6.37-4.44h0l3.4,4.93a3.87,3.87,0,0,1-6.37,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1805.31,454.07c-1.26-1.42-2.5-2.87-3.8-4.26a3.91,3.91,0,0,1,5.71-5.34h0v0c1.36,1.46,2.66,3,4,4.48a3.9,3.9,0,0,1-5.84,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1792,440.45l-4.3-3.77-.1-.09a3.94,3.94,0,1,1,5.19-5.92h0l4.5,4a3.93,3.93,0,1,1-5.2,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1777.22,428.5l-4.71-3.25-.11-.07a4,4,0,0,1,4.51-6.53h0l4.92,3.41a4,4,0,1,1-4.51,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1761.13,418.3l-5-2.71-.12-.06a4,4,0,0,1,3.78-7h0l5.26,2.84a4,4,0,1,1-3.79,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1744,409.9l-5.3-2.17-.11,0a4,4,0,1,1,3-7.44h0l5.53,2.28a4,4,0,1,1-3.06,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1726.09,403.3l-5.49-1.62-.12,0a4,4,0,0,1,2.3-7.76h0l5.72,1.71a4,4,0,0,1-2.31,7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1707.6,398.52l-5.63-1.09-.11,0a4.07,4.07,0,0,1,1.54-8h0l5.86,1.15a4.07,4.07,0,0,1-1.56,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1688.72,395.54,1683,395h-.12a4.1,4.1,0,0,1,.77-8.17h0l5.95.58a4.09,4.09,0,0,1-.79,8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1669.65,394.37h-5.86a4.13,4.13,0,1,1,0-8.25h6a4.12,4.12,0,0,1,0,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1650.55,395l-5.7.56h-.13a4.15,4.15,0,0,1-.81-8.27h0l5.95-.57a4.15,4.15,0,1,1,.79,8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1631.62,397.56l-5.63,1.1-.11,0a4.18,4.18,0,0,1-1.61-8.21h0l5.85-1.13a4.18,4.18,0,0,1,1.58,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1613,401.82l-5.51,1.6-.11,0a4.21,4.21,0,0,1-2.34-8.09h0l5.73-1.65a4.2,4.2,0,1,1,2.31,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1594.77,407.7l-5.36,2.06-.1,0a4.24,4.24,0,1,1-3-7.91h0l5.56-2.12a4.23,4.23,0,1,1,3,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1577.1,415.08l-5.18,2.49-.09,0a4.26,4.26,0,0,1-3.7-7.68h0l5.37-2.56a4.26,4.26,0,1,1,3.67,7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1560.06,423.85l-5,2.88-.09,0a4.28,4.28,0,0,1-4.28-7.41l5.15-3a4.28,4.28,0,1,1,4.29,7.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1543.7,433.86l-4.76,3.23-.08.05a4.25,4.25,0,0,1-4.78-7l4.9-3.35a4.26,4.26,0,1,1,4.8,7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1528.1,445l-4.53,3.57-.07,0a4.21,4.21,0,0,1-5.23-6.61l4.66-3.69a4.22,4.22,0,0,1,5.25,6.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1513.31,457.29l-4.28,3.87-.06.06a4.18,4.18,0,0,1-5.63-6.19l4.39-4a4.19,4.19,0,1,1,5.65,6.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1499.38,470.53l-4,4.16,0,.06a4.15,4.15,0,0,1-6-5.75l4.1-4.29a4.16,4.16,0,0,1,6,5.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1486.37,484.7l-3.72,4.41-.05.06a4.12,4.12,0,0,1-6.31-5.3l3.8-4.55a4.13,4.13,0,0,1,6.34,5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1474.29,499.68l-3.46,4.64,0,.05a4.09,4.09,0,0,1-6.56-4.87l3.52-4.76a4.1,4.1,0,0,1,6.59,4.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1463.05,515.36l-3.22,4.81,0,.05a4.06,4.06,0,0,1-6.75-4.5l3.26-4.92a4.07,4.07,0,1,1,6.78,4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1452.56,531.58l-3,5,0,0a4,4,0,0,1-6.88-4.17l3-5a4,4,0,1,1,6.91,4.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1442.71,548.25l-2.85,5.06,0,0a4,4,0,0,1-7-3.9l2.87-5.14a4,4,0,1,1,7,3.9v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1433.36,565.24l-2.73,5.15v0a4,4,0,0,1-7-3.7l2.73-5.2a4,4,0,0,1,7,3.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1424.38,582.47l-2.64,5.2h0a3.93,3.93,0,0,1-7-3.55l2.64-5.24a3.94,3.94,0,0,1,7,3.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1415.63,599.85l-2.6,5.24a3.9,3.9,0,0,1-7-3.46l2.6-5.25a3.91,3.91,0,1,1,7,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1407,617.32l-2.61,5.26a3.87,3.87,0,0,1-6.94-3.44l2.59-5.25a3.88,3.88,0,1,1,7,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1398.27,634.81l-2.65,5.24a3.84,3.84,0,1,1-6.85-3.46h0l2.62-5.23h0a3.85,3.85,0,1,1,6.88,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1389.33,652.21l-2.75,5.2a3.75,3.75,0,0,1-6.64-3.47v0l2.68-5.19v0a3.78,3.78,0,0,1,6.71,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1380,669.46l-2.87,5.14a3.66,3.66,0,0,1-6.4-3.54l0,0,2.79-5.11v0a3.69,3.69,0,1,1,6.47,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1370.24,686.47l-3.07,5a3.56,3.56,0,0,1-6.1-3.67l0,0,3-5,0,0a3.59,3.59,0,0,1,6.17,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1359.77,703.1l-3.29,4.9a3.47,3.47,0,0,1-5.78-3.83l0,0,3.19-4.85,0,0a3.5,3.5,0,0,1,5.85,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1348.55,719.25,1345,724a3.37,3.37,0,0,1-5.44-4l0,0,3.41-4.69,0,0a3.4,3.4,0,1,1,5.5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1336.54,734.83l-3.78,4.55a3.28,3.28,0,0,1-5.07-4.17l0,0,3.66-4.49,0,0a3.31,3.31,0,1,1,5.13,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1323.64,749.72l-4.05,4.31a3.19,3.19,0,0,1-4.67-4.34l0-.05,3.92-4.26,0,0a3.22,3.22,0,0,1,4.73,4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1309.79,763.76l-4.35,4a3.09,3.09,0,0,1-4.22-4.52l0,0,4.21-4,0,0a3.12,3.12,0,0,1,4.28,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1294.93,776.75l-4.66,3.66a3,3,0,0,1-3.73-4.7l.06-.05,4.51-3.61.06,0a3,3,0,1,1,3.78,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1279,788.47l-5,3.22a2.9,2.9,0,0,1-3.18-4.85l.07-.05,4.81-3.18.07-.05a2.93,2.93,0,0,1,3.24,4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1262,798.63l-5.29,2.7a2.78,2.78,0,0,1-2.56-4.93l.08,0,5.09-2.7.08,0a2.82,2.82,0,1,1,2.64,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1244.08,806.93l-5.56,2.1a2.62,2.62,0,0,1-1.9-4.89l.09,0,5.36-2.11.08,0a2.67,2.67,0,1,1,2,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1225.29,813.16c-1.93.48-3.84,1-5.77,1.44a2.47,2.47,0,0,1-1.18-4.8h0c1.86-.47,3.71-1,5.57-1.48l.09,0a2.51,2.51,0,1,1,1.28,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1205.85,817l-5.94.59a2.31,2.31,0,0,1-.5-4.6l.12,0,5.69-.66h.12a2.36,2.36,0,1,1,.54,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1186,817.76l-6-.55a2.16,2.16,0,0,1,.37-4.31h.15l5.69.44h.15a2.21,2.21,0,0,1-.34,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1166.29,814.24c-1.89-.69-3.8-1.29-5.67-2a2,2,0,0,1,1.49-3.74h0c1.76.68,3.58,1.22,5.37,1.84l.17.06a2.06,2.06,0,0,1-1.35,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1148.3,805.4l-4.74-3.72a1.84,1.84,0,0,1,2.24-2.93l.14.11,4.54,3.41.14.11a1.9,1.9,0,1,1-2.29,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1134.08,791.3l-3.21-5.12a1.64,1.64,0,0,1,2.76-1.77l.1.16,3.11,4.73.11.16a1.7,1.7,0,0,1-2.85,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1126,773l-.7-4.47a1.45,1.45,0,0,1,2.86-.48l0,.16.73,4.15,0,.15a1.5,1.5,0,0,1-3,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M457.6,451.2s-10.59,5.14-12.53,11.06c-1.56,4.74-13.26,5.35-14.42,14.69a10.72,10.72,0,0,1-9,9.41c-11.95,1.83-30.37,8-33.32,28.79-2.25,15.84,5.82,21.84,14.3,23.92a12,12,0,0,1,9.1,13.87c-1.21,6,.59,13,11,18.5,23.39,12.35,46.76-29.25,46.76-29.25l4.79-72.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M567.74,412.89S537.63,495,486.33,520.62c0,0,17.08,27.86,26,29.55,0,0,54.8-70.14,60.39-127.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M361.42,906.61l-1.51,12.45a5.15,5.15,0,0,1-4.51,4.5,80.19,80.19,0,0,1-16.66.26,4.4,4.4,0,0,1-3.7-5.71c1.53-4.81,4.32-12,8.35-16.27H357.2A4.26,4.26,0,0,1,361.42,906.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M469.57,760.8l2.33,13.71s-7.8,79-9.19,110.67a24.73,24.73,0,0,0,3.67,14.09l13.57,22L445.46,901l-.69-4.21,5.65-7.76L443,800.42a27.25,27.25,0,0,1,3.09-15l7.14-13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M482.22,924.5h-11a6.64,6.64,0,0,1-5.26-2.58c-3.43-4.46-10.54-13.16-13.94-13.39-4.57-.3-4,16-4,16h-2.56l-3.25-20.22a12,12,0,0,1,6.28-12.51h0s1,7.74,6.71,11.16,23.09,15.68,23.09,15.68a15.43,15.43,0,0,1,4.47.12A2.91,2.91,0,0,1,482.22,924.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M422.33,767.31s-45.72,86.73-53,106.53-9.81,36.32-9.91,37.89c-.15,2.44-3.19,4.78-11.57,4.78-4.33,0-6.45-1.73-7.48-3.41a4.86,4.86,0,0,1-.19-4.73c2.64-5.35,11-22.46,14.15-30.21,3.71-9.27,11.69-51.25,16.07-65.84s9.33-30.43,28.39-45C398.8,767.31,411.89,754.49,422.33,767.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M451.21,625.2c11.8-50-18.08-78.25-18.08-78.25,18.85-18.09,53.2-26.33,53.2-26.33s32.78,24,28.89,42.72c-2.28,11-23,65.85-23,65.85S473,638.27,451.21,625.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M425.06,649.94c4.8-14.46,26.15-24.74,26.15-24.74,21.77,13.07,41,4,41,4s4.31,16.45,1.33,31.74S471.9,774.51,471.9,774.51c-29.37,6-74.55-6-74.55-6C416.06,735.3,420.26,664.4,425.06,649.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M464.9,487.6l-9.59,43.07c-.91,3.79,2.55,3.17,6.38,2.45,6.28-1.19,14.38-3.63,17.08-8.51a4.62,4.62,0,0,0,.5-1.63l4.11-29.86a5.36,5.36,0,0,0-3.14-5.64L472.29,484A5.37,5.37,0,0,0,464.9,487.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M433.13,547s-66.93,47.89-8.56,98.2a15.11,15.11,0,0,0,6.6,3.83c2.21.66,8.75,5.6,12.07,8.18a2.27,2.27,0,0,0,3.32-.59h0a3.1,3.1,0,0,0,.17-3l-8.28-17.52a6.39,6.39,0,0,0-8.3-.36h0a3.15,3.15,0,0,1-4.78-1.08c-4.51-9.19-13-36.22,21.84-66.76a3.77,3.77,0,0,0,.83-4.59C445.6,558.57,440,549.23,433.13,547Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M476.15,469.35s11.36,2.46,19.08,10.86,2,12.28-5.29,12.81-18.07.45-29.53-5S461.39,466.44,476.15,469.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M468.11,483.56s-8.56-12.29,12.72-12.43l5,1.79s7.81-6.82-5-10.07-27.82-.57-33.28,8.28-6.38,14.75,2.69,19,12.82-.56,12.82-.56-4.94-4-2.93-6.07,6.65.43,6.65.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M467.34,484.93s-4.33-6.33-10.11-3.81,4.7,5.85,8.8,6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M570.63,427.83c.46,1.46-4.86,3.69-8-2.29-.11-2.86-1.85-15.12-.14-17.45,9.11-12.42,26.77-28,26.77-28a4.2,4.2,0,0,1,.53,5.84l-8.57,8.92c1.79,3.24,4,6,5,9.89a12,12,0,0,1-1.2,8.84c-1.5,2.71-3.55,6.23-5.49,9A11.86,11.86,0,0,1,570.63,427.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M575,421.73c.64-3.6,2.61-13.42,4-15.63a5,5,0,0,0,.95-3.93,3.63,3.63,0,0,0-2-2.23l-.47-.24L569,406.8l-2.53,6.79,1.5.55,2.38-6.39,7.22-6.12a1.8,1.8,0,0,1,.78,1,3.65,3.65,0,0,1-.77,2.66c-1.79,2.93-4.09,15.64-4.18,16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M511.09,1465a4.46,4.46,0,0,1-4.45-4.46V928.25a4.45,4.45,0,1,1,8.9,0v532.26A4.46,4.46,0,0,1,511.09,1465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M390.42,1465a4.46,4.46,0,0,1-4.46-4.46V928.25a4.46,4.46,0,0,1,8.91,0v532.26A4.46,4.46,0,0,1,390.42,1465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M93.94,1468.34a4.31,4.31,0,0,1-1.74-.36,4.46,4.46,0,0,1-2.36-5.84L317.55,926.51a4.45,4.45,0,1,1,8.2,3.48L98,1465.63A4.46,4.46,0,0,1,93.94,1468.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M234.59,1468.34a4.31,4.31,0,0,1-1.74-.36,4.45,4.45,0,0,1-2.35-5.84L458.21,926.51a4.45,4.45,0,1,1,8.2,3.48L238.69,1465.63A4.45,4.45,0,0,1,234.59,1468.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M518,933.15H309.41a6.28,6.28,0,0,1-6.27-6.28h0a6.27,6.27,0,0,1,6.27-6.27H518a6.28,6.28,0,0,1,6.28,6.27h0A6.28,6.28,0,0,1,518,933.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M427.91,1014.61H286.83a4.46,4.46,0,0,1,0-8.91H427.91a4.46,4.46,0,0,1,0,8.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 243.55,
    y: 1107,
    width: 141.07,
    height: 8.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 201.64,
    y: 1208.31,
    width: 141.07,
    height: 8.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M298.77,1318.51H157.7a4.45,4.45,0,1,1,0-8.9H298.77a4.45,4.45,0,1,1,0,8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M256.28,1419.82H115.21a4.46,4.46,0,0,1,0-8.91H256.28a4.46,4.46,0,1,1,0,8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M859.76,1329.61h-.33l-121.13-1.16c-17.31-.17-31.59-12.08-33.23-27.7l-10.65-101.63a22.1,22.1,0,0,1,5.21-16.61,26.59,26.59,0,0,1,18.54-9.14h0c10.2-.7,24.58-1.92,39.79-3.22,32-2.73,71.91-6.12,94.34-6.4,16.28-.08,30.09,9.55,33.92,23.72,6.31,23.33,5.76,67.5,4.56,114.54C890.39,1317.29,876.51,1329.61,859.76,1329.61Zm-141-147a17.22,17.22,0,0,0-12,5.85,12.85,12.85,0,0,0-3.09,9.65l10.65,101.63c1.14,10.92,11.49,19.24,24.07,19.37l121.13,1.16h.24c11.74,0,21.46-8.27,21.72-18.53,1.18-46.34,1.75-89.76-4.24-111.88-2.68-9.92-13-16.81-24.82-16.85-22.1.28-61.78,3.65-93.67,6.37-15.25,1.3-29.67,2.53-40,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M731.84,1193.14c25.44-1.74,80.75-7.36,107-7.68,11.11-.14,20.86,6.57,23.47,16.21,5.06,18.72,4.39,56,3.51,90.47-.26,10.31-9.73,18.54-21.3,18.43l-96.8-.93c-11.9-.11-21.78-8.23-22.89-18.8l-8.51-81.22C715.42,1201.22,722.4,1193.78,731.84,1193.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M737,1209.08h0a18.6,18.6,0,0,1,25.65,7l23.89,42.83a6,6,0,0,0,10.66-.46l59.26-131.93c2.95-6.58,12.75-4.35,12.65,2.86-.61,40.35-11.32,117.06-75.79,181.27,0,0-35.54-13.81-64.15-76.65A19.49,19.49,0,0,1,737,1209.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1092.66,1329.61h-.33l-121.13-1.16c-17.31-.17-31.59-12.08-33.23-27.7l-10.65-101.63a22.1,22.1,0,0,1,5.21-16.61,26.59,26.59,0,0,1,18.54-9.14h0c10.2-.7,24.58-1.92,39.79-3.22,32-2.73,71.91-6.12,94.34-6.4,16.28-.08,30.09,9.55,33.92,23.72,6.31,23.33,5.76,67.5,4.56,114.54C1123.29,1317.29,1109.4,1329.61,1092.66,1329.61Zm-141-147a17.2,17.2,0,0,0-12,5.85,12.85,12.85,0,0,0-3.09,9.65l10.65,101.63c1.14,10.92,11.49,19.24,24.07,19.37l121.13,1.16h.24c11.74,0,21.46-8.27,21.72-18.53,1.18-46.34,1.75-89.76-4.24-111.88-2.68-9.92-13-16.81-24.82-16.85-22.1.28-61.78,3.65-93.67,6.37-15.26,1.3-29.67,2.53-39.95,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M964.74,1193.14c25.44-1.74,80.75-7.36,107-7.68,11.11-.14,20.86,6.57,23.47,16.21,5.06,18.72,4.39,56,3.51,90.47-.26,10.31-9.73,18.54-21.3,18.43l-96.8-.93c-11.9-.11-21.79-8.23-22.89-18.8l-8.51-81.22C948.32,1201.22,955.3,1193.78,964.74,1193.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M969.89,1209.08h0a18.6,18.6,0,0,1,25.65,7l23.89,42.83a6,6,0,0,0,10.66-.46l59.26-131.93c3-6.58,12.75-4.35,12.65,2.86-.61,40.35-11.32,117.06-75.8,181.27,0,0-35.53-13.81-64.14-76.65A19.49,19.49,0,0,1,969.89,1209.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1325.56,1329.61h-.33l-121.13-1.16c-17.31-.17-31.59-12.08-33.23-27.7l-10.65-101.63a22.1,22.1,0,0,1,5.21-16.61,26.59,26.59,0,0,1,18.54-9.14h0c10.2-.7,24.58-1.92,39.79-3.22,32-2.73,71.91-6.12,94.34-6.4,16.28-.08,30.09,9.55,33.92,23.72,6.31,23.33,5.76,67.5,4.56,114.54C1356.19,1317.29,1342.3,1329.61,1325.56,1329.61Zm-141-147a17.2,17.2,0,0,0-12,5.85,12.85,12.85,0,0,0-3.09,9.65l10.65,101.63c1.14,10.92,11.49,19.24,24.07,19.37l121.13,1.16h.24c11.74,0,21.46-8.27,21.72-18.53,1.18-46.34,1.75-89.76-4.24-111.88-2.68-9.92-13-16.81-24.82-16.85-22.1.28-61.78,3.65-93.67,6.37-15.26,1.3-29.67,2.53-40,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1197.63,1193.14c25.45-1.74,80.76-7.36,107-7.68,11.11-.14,20.86,6.57,23.47,16.21,5.06,18.72,4.39,56,3.51,90.47-.26,10.31-9.73,18.54-21.3,18.43l-96.8-.93c-11.9-.11-21.79-8.23-22.89-18.8l-8.51-81.22C1181.22,1201.22,1188.2,1193.78,1197.63,1193.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M748.41,537.19l-5.92,1.26a3,3,0,1,1-1.27-6h0l5.93-1.22a3,3,0,0,1,1.24,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M728.8,541.56,722.92,543a3.11,3.11,0,1,1-1.46-6h0l5.89-1.38a3.09,3.09,0,0,1,1.43,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M709.31,546.43,703.47,548a3.17,3.17,0,1,1-1.65-6.12h0l5.86-1.53a3.14,3.14,0,0,1,1.61,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M690,551.82l-5.81,1.71a3.23,3.23,0,1,1-1.83-6.19h0l5.81-1.68a3.22,3.22,0,0,1,1.81,6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M670.75,557.69,665,559.56a3.29,3.29,0,1,1-2-6.26h0l5.77-1.83a3.27,3.27,0,0,1,2,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M651.7,564.06l-5.71,2a3.35,3.35,0,1,1-2.23-6.32h0l5.72-2a3.34,3.34,0,0,1,2.2,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M632.82,570.91l-5.66,2.16a3.42,3.42,0,1,1-2.43-6.39h0l5.66-2.12a3.4,3.4,0,0,1,2.41,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M614.12,578.23l-5.6,2.3a3.48,3.48,0,1,1-2.64-6.44h0l5.61-2.27a3.46,3.46,0,0,1,2.61,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.61,586l-5.54,2.44a3.54,3.54,0,0,1-2.86-6.48h0l5.56-2.4a3.52,3.52,0,0,1,2.82,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M577.3,594.27l-5.48,2.58a3.6,3.6,0,0,1-3.07-6.52h0l5.5-2.54a3.58,3.58,0,0,1,3,6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.2,603l-5.41,2.71a3.67,3.67,0,0,1-3.29-6.56h0l5.42-2.68A3.65,3.65,0,0,1,559.2,603Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M541.32,612.12,536,615a3.73,3.73,0,0,1-3.5-6.59h0l5.36-2.81a3.71,3.71,0,0,1,3.46,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M523.68,621.71l-5.27,3a3.79,3.79,0,1,1-3.73-6.6h0l5.29-2.94a3.77,3.77,0,0,1,3.69,6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M506.28,631.72l-5.2,3.1a3.85,3.85,0,1,1-3.95-6.61l0,0,5.22-3.07a3.84,3.84,0,0,1,3.91,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M489.13,642.16,484,645.38a3.91,3.91,0,1,1-4.18-6.62h0l5.14-3.2a3.9,3.9,0,0,1,4.14,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M472.24,653l-5,3.35a4,4,0,1,1-4.41-6.62l0,0,5.06-3.32a4,4,0,0,1,4.37,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M455.62,664.27l-5,3.47a4,4,0,1,1-4.64-6.61l0,0,5-3.44a4,4,0,0,1,4.6,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M439.27,675.92l-4.87,3.59a4.08,4.08,0,0,1-4.84-6.58h0l4.88-3.57a4.07,4.07,0,1,1,4.82,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423.2,688l-4.78,3.7a4.11,4.11,0,1,1-5-6.5h0l4.79-3.69a4.1,4.1,0,0,1,5,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M407.43,700.36l-4.69,3.82a4.14,4.14,0,1,1-5.23-6.42h0l4.71-3.8a4.13,4.13,0,1,1,5.2,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M392,713.16l-4.6,3.93a4.17,4.17,0,0,1-5.42-6.34h0l4.61-3.92a4.16,4.16,0,0,1,5.4,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M376.82,726.32l-4.5,4a4.19,4.19,0,1,1-5.6-6.23h0l4.52-4a4.18,4.18,0,1,1,5.58,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362,739.86,357.6,744a4.22,4.22,0,1,1-5.79-6.14h0l4.42-4.14a4.21,4.21,0,0,1,5.77,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M347.52,753.75l-4.3,4.25a4.25,4.25,0,0,1-6-6h0l4.31-4.24a4.24,4.24,0,0,1,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.38,768l-4.19,4.36a4.28,4.28,0,1,1-6.16-5.93h0l4.2-4.34a4.26,4.26,0,0,1,6.14,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.61,782.56,315.52,787a4.3,4.3,0,1,1-6.34-5.81h0l4.1-4.45a4.3,4.3,0,0,1,6.33,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.19,797.47l-4,4.57a4.33,4.33,0,1,1-6.53-5.69h0l4-4.55a4.32,4.32,0,0,1,6.51,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.18,812.71l-3.84,4.69a4.36,4.36,0,1,1-6.74-5.52h0l3.85-4.68a4.35,4.35,0,0,1,6.72,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.71,828.36l-3.66,4.82a4.38,4.38,0,1,1-7-5.29h0l3.67-4.81a4.38,4.38,0,0,1,7,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.86,844.46l-3.45,5a4.41,4.41,0,0,1-7.25-5h0l3.47-5a4.4,4.4,0,0,1,7.22,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.73,861l-3.22,5.12a4.44,4.44,0,1,1-7.52-4.72h0l3.23-5.12a4.43,4.43,0,0,1,7.5,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.41,878.11l-3,5.28a4.46,4.46,0,1,1-7.79-4.36h0l3-5.28a4.46,4.46,0,0,1,7.78,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238,895.67l-2.65,5.44a4.49,4.49,0,1,1-8.08-3.92v0l2.66-5.43a4.49,4.49,0,0,1,8.07,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.73,913.74l-2.29,5.6a4.52,4.52,0,1,1-8.37-3.42h0l2.3-5.6a4.51,4.51,0,0,1,8.35,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.69,932.28,220.82,938a4.55,4.55,0,0,1-8.65-2.81h0l1.89-5.75a4.54,4.54,0,0,1,8.63,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.11,951.27l-1.39,5.9a4.58,4.58,0,0,1-8.91-2.1h0l1.4-5.89a4.57,4.57,0,0,1,8.89,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.19,970.62l-.83,6a4.6,4.6,0,0,1-9.12-1.27h0l.85-6a4.59,4.59,0,0,1,9.1,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.15,990.21l-.22,6a4.63,4.63,0,1,1-9.25-.34h0l.23-6a4.62,4.62,0,1,1,9.24.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.16,1009.87l.43,6a4.63,4.63,0,0,1-9.23.66l-.44-6a4.63,4.63,0,0,1,9.24-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.34,1029.38l1.12,5.95a4.63,4.63,0,0,1-9.09,1.72l-1.12-6a4.63,4.63,0,0,1,9.09-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.77,1048.49l1.81,5.78a4.62,4.62,0,1,1-8.81,2.77l-1.82-5.77a4.62,4.62,0,1,1,8.82-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.41,1067l2.46,5.52a4.62,4.62,0,1,1-8.44,3.76l-2.47-5.52a4.62,4.62,0,0,1,8.45-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.08,1084.63l3,5.23a4.62,4.62,0,1,1-8,4.64l-3-5.23a4.62,4.62,0,0,1,8-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.56,1101.31l3.55,4.9a4.62,4.62,0,1,1-7.48,5.41l-3.55-4.9a4.62,4.62,0,1,1,7.48-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.65,1116.91l4,4.56a4.61,4.61,0,1,1-6.94,6.07l-4-4.55a4.61,4.61,0,0,1,6.94-6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269.12,1131.37l4.37,4.19a4.61,4.61,0,0,1-6.38,6.66l-4.37-4.19a4.61,4.61,0,1,1,6.38-6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.8,1144.64l4.7,3.81a4.61,4.61,0,1,1-5.8,7.16l-4.7-3.81a4.61,4.61,0,0,1,5.8-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.53,1156.67l5,3.42a4.61,4.61,0,1,1-5.21,7.6l-5-3.42a4.61,4.61,0,1,1,5.21-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.19,1167.42l5.2,3,.05,0a4.6,4.6,0,1,1-4.59,8l-5.29-3a4.61,4.61,0,0,1,4.59-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.61,1176.88l5.45,2.64a4.6,4.6,0,1,1-4,8.28l-5.44-2.64a4.6,4.6,0,1,1,4-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.68,1185.12l5.61,2.26a4.6,4.6,0,0,1-3.44,8.53l-5.61-2.26a4.6,4.6,0,1,1,3.44-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.27,1192.11,376,1194a4.59,4.59,0,1,1-2.86,8.73l-5.75-1.88a4.6,4.6,0,0,1,2.86-8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.28,1197.88l5.86,1.51a4.6,4.6,0,0,1-2.3,8.9l-5.86-1.52a4.59,4.59,0,1,1,2.3-8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.64,1202.45l5.93,1.15a4.59,4.59,0,0,1-1.75,9l-5.94-1.16a4.59,4.59,0,1,1,1.75-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M428.24,1205.86l6,.82a4.59,4.59,0,0,1-1.24,9.09l-6-.82a4.59,4.59,0,0,1,1.24-9.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M448,1208.17l6,.5a4.59,4.59,0,0,1-.75,9.14l-6-.49a4.59,4.59,0,0,1,.75-9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M467.92,1209.44l6.05.19a4.58,4.58,0,1,1-.28,9.16l-6.05-.18a4.59,4.59,0,0,1,.28-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M487.87,1209.73l6.05-.1a4.58,4.58,0,1,1,.15,9.16l-6.05.1a4.58,4.58,0,1,1-.15-9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M507.83,1209.1l6-.36a4.58,4.58,0,1,1,.55,9.14l-6,.36a4.58,4.58,0,0,1-.55-9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M527.76,1207.61l6-.61a4.57,4.57,0,0,1,.93,9.1l-6,.61a4.57,4.57,0,1,1-.92-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M547.61,1205.31l6-.84a4.57,4.57,0,1,1,1.28,9.06l-6,.84a4.57,4.57,0,0,1-1.28-9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M567.39,1202.27l6-1.06a4.57,4.57,0,0,1,1.6,9l-6,1.06a4.57,4.57,0,1,1-1.6-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M587.05,1198.52l5.92-1.26a4.57,4.57,0,1,1,1.91,8.93l-5.92,1.27a4.57,4.57,0,1,1-1.91-8.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M606.58,1194.11l5.88-1.45a4.56,4.56,0,1,1,2.19,8.86l-5.87,1.46a4.57,4.57,0,0,1-2.2-8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M626,1189.09l5.83-1.64a4.57,4.57,0,0,1,2.47,8.79l-5.83,1.64a4.57,4.57,0,0,1-2.47-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M645.21,1183.48l5.78-1.81a4.56,4.56,0,1,1,2.72,8.71l-5.78,1.81a4.56,4.56,0,0,1-2.72-8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M664.31,1177.34l5.73-1.94A4.52,4.52,0,0,1,673,1184l-5.72,2a4.53,4.53,0,1,1-3-8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M683.28,1170.77l5.69-2.06a4.48,4.48,0,0,1,3.07,8.41l-5.69,2.08a4.49,4.49,0,0,1-3.09-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M702.13,1163.81l5.65-2.16a4.43,4.43,0,0,1,3.18,8.28l-5.64,2.18a4.44,4.44,0,1,1-3.21-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M720.86,1156.53l5.62-2.24a4.39,4.39,0,0,1,3.27,8.14l-5.6,2.27a4.4,4.4,0,0,1-3.3-8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M739.5,1149l5.59-2.32a4.34,4.34,0,0,1,3.34,8l-5.58,2.34a4.35,4.35,0,0,1-3.37-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M758.07,1141.2l5.57-2.37a4.3,4.3,0,0,1,3.39,7.9l-5.56,2.4a4.31,4.31,0,1,1-3.42-7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M776.58,1133.26l5.56-2.42a4.25,4.25,0,0,1,3.4,7.8l-5.54,2.44a4.27,4.27,0,1,1-3.44-7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M795.06,1125.19l5.54-2.43a4.2,4.2,0,0,1,3.4,7.69l-5.53,2.46a4.22,4.22,0,0,1-3.43-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M813.51,1117.06l5.54-2.45a4.16,4.16,0,0,1,3.38,7.61l-5.53,2.47a4.17,4.17,0,1,1-3.41-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M832,1108.91l5.54-2.44a4.12,4.12,0,0,1,3.33,7.53l-5.52,2.47a4.13,4.13,0,0,1-3.37-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M850.45,1100.79l5.55-2.42a4.08,4.08,0,0,1,3.27,7.47l-5.53,2.44a4.09,4.09,0,1,1-3.31-7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M869,1092.76l5.56-2.39a4,4,0,0,1,3.19,7.41l-5.55,2.4a4,4,0,1,1-3.21-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M887.58,1084.85l5.6-2.33a4,4,0,0,1,3.08,7.35l-5.58,2.36a4,4,0,0,1-3.11-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M906.28,1077.13l5.62-2.26a3.94,3.94,0,0,1,3,7.3l-5.6,2.29a4,4,0,0,1-3-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M925.08,1069.65l5.65-2.18a3.9,3.9,0,0,1,2.83,7.26l-5.64,2.21a3.91,3.91,0,1,1-2.85-7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M944,1062.49l5.69-2.07a3.81,3.81,0,0,1,2.64,7.14l-5.67,2.13a3.84,3.84,0,0,1-2.7-7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M963.1,1055.7l5.73-2a3.71,3.71,0,0,1,2.43,7l-5.71,2a3.74,3.74,0,1,1-2.49-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M982.32,1049.31l5.79-1.82a3.61,3.61,0,0,1,2.21,6.87h0l-5.75,1.88h0a3.64,3.64,0,0,1-2.26-6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1001.73,1043.41l5.82-1.65a3.51,3.51,0,0,1,2,6.74l-5.81,1.71a3.54,3.54,0,0,1-2-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1021.3,1038.09l5.87-1.47a3.41,3.41,0,0,1,1.69,6.6l-5.86,1.53a3.44,3.44,0,0,1-1.73-6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1041,1033.38l5.92-1.28a3.31,3.31,0,0,1,1.43,6.46l-5.9,1.34a3.34,3.34,0,0,1-1.48-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1060.9,1029.32l5.95-1.08a3.21,3.21,0,0,1,1.18,6.31l-6,1.14a3.24,3.24,0,1,1-1.21-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1080.9,1026l6-.86a3.11,3.11,0,0,1,.92,6.15l-6,.92a3.14,3.14,0,0,1-1-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1101,1023.32l6-.64a3,3,0,0,1,.66,6l-6,.7a3,3,0,0,1-.7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1121.23,1021.47l6-.39a2.91,2.91,0,0,1,.4,5.8l-6,.45a2.94,2.94,0,0,1-.44-5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1141.5,1020.46l6-.13a2.81,2.81,0,0,1,.15,5.62l-6,.18a2.84,2.84,0,1,1-.18-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1161.8,1020.38l6,.16a2.67,2.67,0,0,1-.11,5.34l-6-.08a2.72,2.72,0,0,1,.07-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1182.08,1021.28l6,.47a2.52,2.52,0,0,1-.35,5l-6-.38a2.56,2.56,0,1,1,.32-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1202.29,1023.21l6,.79a2.36,2.36,0,0,1-.58,4.69l-6-.7a2.41,2.41,0,1,1,.55-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1222.36,1026.23l6,1.12a2.21,2.21,0,0,1-.78,4.35l-6-1a2.26,2.26,0,0,1,.77-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1242.23,1030.4l5.87,1.47a2.06,2.06,0,0,1-1,4l-5.89-1.39a2.1,2.1,0,1,1,1-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1261.8,1035.76l5.77,1.84a1.91,1.91,0,0,1-1.13,3.64l-5.79-1.75a2,2,0,1,1,1.13-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1281,1042.37l5.63,2.21a1.75,1.75,0,0,1-1.25,3.27l-5.67-2.13a1.79,1.79,0,1,1,1.26-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1299.67,1050.26l5.47,2.6a1.55,1.55,0,0,1-1.31,2.82l-5.51-2.5a1.61,1.61,0,1,1,1.33-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1317.76,1059.43l5.26,3a1.35,1.35,0,0,1-1.3,2.37l-5.33-2.88a1.41,1.41,0,0,1,1.34-2.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1136.76 732.61 1116.23 761.05 1105.8 734.92 1136.76 732.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1020.67,624l28.16,122.81a8.87,8.87,0,0,0,11,6.58L1182,720.44a3.56,3.56,0,0,0,.8-6.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1136.75 732.61 1020.67 623.97 1117.04 737.99 1111.68 746.11 1136.75 732.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1105.33 741.08 1116.23 761.05 1117.04 737.99 1105.33 741.08"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpImg1);
export default __webpack_public_path__ + "static/media/erp_img_1.d2a6f1aca5c568d266628d10a59ce6fc.svg";
export { ForwardRef as ReactComponent };